import { render } from "./PolitiquesRgpd.vue?vue&type=template&id=9ab69cb4"
import script from "./PolitiquesRgpd.vue?vue&type=script&lang=js"
export * from "./PolitiquesRgpd.vue?vue&type=script&lang=js"

import "./PolitiquesRgpd.vue?vue&type=style&index=0&id=9ab69cb4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__